<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('roles.edit') }}</h1>
          <hr />
          <role-form :role-id="$route.params.id" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import RoleForm from '@/components/roles/RoleForm.vue';

export default {
  components: { RoleForm },
};
</script>

<style></style>
